// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { APPRelationship } from './APPRelationship';
import { APPComponent } from './APPComponent';
import { MenuSet } from './MenuSet';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { MenuContainExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/APPModel/MenuContainExtend';
/**
 * 菜单主子关系 实体类
 * 菜单主子关系
 */
export class MenuContain extends APPRelationship {
  /** 应用组件 的ID */
  private _aPPComponent_ID: string;

  /** 获取：应用组件 的ID */
  public get aPPComponent_ID() {
    return this._aPPComponent_ID;
  }

  /** 设置：应用组件 的ID */
  public set aPPComponent_ID(value: string) {
    this._aPPComponent_ID = value;
  }

  /** 应用组件  */
  private _aPPComponent: APPComponent;

  /** 获取：应用组件  */
  public get aPPComponent() {
    return this._aPPComponent;
  }

  /** 设置：应用组件  */
  public set aPPComponent(value: APPComponent) {
    this._aPPComponent = value;
    if (value !== null) {
      this.aPPComponent_ID = value.id;
    } else {
      this.aPPComponent_ID = '';
    }
  }

  /** 主菜单集 的ID */
  private _mainMenuSet_ID: string;

  /** 获取：主菜单集 的ID */
  public get mainMenuSet_ID() {
    return this._mainMenuSet_ID;
  }

  /** 设置：主菜单集 的ID */
  public set mainMenuSet_ID(value: string) {
    this._mainMenuSet_ID = value;
  }

  /** 主菜单集  */
  private _mainMenuSet: MenuSet;

  /** 获取：主菜单集  */
  public get mainMenuSet() {
    return this._mainMenuSet;
  }

  /** 设置：主菜单集  */
  public set mainMenuSet(value: MenuSet) {
    this._mainMenuSet = value;
    if (value !== null) {
      this.mainMenuSet_ID = value.id;
    } else {
      this.mainMenuSet_ID = '';
    }
  }

  /** 子菜单集 的ID */
  private _subMenuSet_ID: string;

  /** 获取：子菜单集 的ID */
  public get subMenuSet_ID() {
    return this._subMenuSet_ID;
  }

  /** 设置：子菜单集 的ID */
  public set subMenuSet_ID(value: string) {
    this._subMenuSet_ID = value;
  }

  /** 子菜单集  */
  private _subMenuSet: MenuSet;

  /** 获取：子菜单集  */
  public get subMenuSet() {
    return this._subMenuSet;
  }

  /** 设置：子菜单集  */
  public set subMenuSet(value: MenuSet) {
    this._subMenuSet = value;
    if (value !== null) {
      this.subMenuSet_ID = value.id;
    } else {
      this.subMenuSet_ID = '';
    }
  }

  constructor() {
    super();
    MenuContainExtend.Init(this);
    this._aPPComponent_ID = '';
    this._aPPComponent = null;
    this._mainMenuSet_ID = '';
    this._mainMenuSet = null;
    this._subMenuSet_ID = '';
    this._subMenuSet = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: MenuContain, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.aPPComponent_ID = element.aPPComponent_ID;
      if (hasReference && element.aPPComponent !== null) {
        this.aPPComponent = element.aPPComponent;
      }
      this.mainMenuSet_ID = element.mainMenuSet_ID;
      if (hasReference && element.mainMenuSet !== null) {
        this.mainMenuSet = element.mainMenuSet;
      }
      this.subMenuSet_ID = element.subMenuSet_ID;
      if (hasReference && element.subMenuSet !== null) {
        this.subMenuSet = element.subMenuSet;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.aPPComponent_ID = json.APPComponent_ID;
    // if (json.APPComponent !== null) {
    //   this.aPPComponent = APPComponent.Create(json.APPComponent);
    // }
    this.mainMenuSet_ID = json.MainMenuSet_ID;
    // if (json.MainMenuSet !== null) {
    //   this.mainMenuSet = MenuSet.Create(json.MainMenuSet);
    // }
    this.subMenuSet_ID = json.SubMenuSet_ID;
    // if (json.SubMenuSet !== null) {
    //   this.subMenuSet = MenuSet.Create(json.SubMenuSet);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.APPComponent_ID = this.aPPComponent_ID;
    json.MainMenuSet_ID = this.mainMenuSet_ID;
    json.SubMenuSet_ID = this.subMenuSet_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): MenuContain {
    const menuContain = new MenuContain();
    menuContain.Deserialize(json);
    menuContain.json = json;
    return menuContain;
  }
}
